import { render, staticRenderFns } from "./NewspaperImage.vue?vue&type=template&id=d81d4734"
import script from "./NewspaperImage.vue?vue&type=script&lang=js"
export * from "./NewspaperImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports